export default "__VITE_ASSET__bgHfAawz__"